import axios from 'axios'
import {Currency, Unit, Taxes} from './models'
import {ID} from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL

const getCurrency = async (): Promise<Currency> => {
  const response = await axios.get(`${API_URL}/currencies`)
  return response.data
}

const getCurrencyById = async (currencyId: number | undefined): Promise<Currency> => {
  const response = await axios.get(`${API_URL}/currencies/${currencyId}`)
  return response.data
}

const createCurrency = async (formData: any): Promise<void> => {
  try {
    const response = axios.post(`${API_URL}/currencies`, formData)
  } catch (error: any) {
    console.error('Failed to create currency', error)
    return Promise.reject(error.response.data.message || 'Failed to create currency')
  }
}

const updateCurrencies = async (id: ID | undefined, formData: any): Promise<void> => {
  try {
    const response = axios.put(`${API_URL}/currencies/${id}`, formData)
  } catch (error: any) {
    console.error('Failed to update devise', error)
    return Promise.reject(error.response.data.message || 'Failed to update devise')
  }
}

const getUnits = async (): Promise<Unit> => {
  const response = await axios.get(`${API_URL}/units`)
  return response.data
}

const deleteUnit = (unitId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/units/${unitId}`).then(() => {})
}

const createUnits = async (formData: any): Promise<void> => {
  try {
    const response = axios.post(`${API_URL}/units`, formData)
  } catch (error: any) {
    console.error('Failed to create unit', error)
    return Promise.reject(error.response.data.message || 'Failed to create unit')
  }
}

const getTaxes = async (): Promise<Taxes> => {
  const response = await axios.get(`${API_URL}/taxes`)
  return response.data
}

const createTaxes = async (formData: any): Promise<void> => {
  try {
    const response = axios.post(`${API_URL}/taxes`, formData)
  } catch (error: any) {
    console.error('Failed to create tax', error)
    return Promise.reject(error.response.data.message || 'Failed to create tax')
  }
}
const updateTaxes = async (formData: any): Promise<void> => {

  try {
    const response = axios.put(`${API_URL}/taxes`, formData)
  } catch (error: any) {
    console.error('Failed to create tax', error)
    return Promise.reject(error.response.data.message || 'Failed to create tax')
  }
}

export {
  getCurrency,
  getUnits,
  createCurrency,
  createUnits,
  getTaxes,
  createTaxes,
  updateTaxes,
  deleteUnit,
  updateCurrencies,
  getCurrencyById,
}
